import Vue from 'vue'
import {tap, map} from 'rxjs/operators'
import {
  filter as _filter,
  sumBy,
  sortBy,
  find as _find,
  isEmpty as _isEmpty,
  reduce as _reduce,
  map as _map,
  every as _every
} from 'lodash-es'
import moment from 'moment-timezone'

import {types as hierarchyTypes, namespace as hierarchyNamespace} from './service-hierarchy-store'
import {calculationService} from '../../service/calculation-service'
import i18n from '../../i18n'
import {parseServiceName} from '../../common/service-name-utils'
import {getExtraServiceName} from '../../components/calculator/services/ChildServiceUtils'

export const namespace = 'CALCULATION'

export const types = {
  SET_DETAIL_SHOW: 'setDetailShow',
  SET_SELECTED_PARENT_HOMEPAGE_UI_NAME: 'setSelectedParentHomepageUiName',
  SET_SELECTED_HOMEPAGE_UI_NAME: 'setSelectedHomepageUiName',
  SET_SELECTED_CALCULATION_SERVICES: 'setSelectedCalculationServices',
  GET_METADATAS_BY_PARENT_HOMEPAGE_UI_NAME: 'getMetadatasByParentHomepageUiName',
  GET_CALCULATION_ITEMS_BY_CATEGORY: 'getCalculationItemsByCategory',
  SET_SELECTED_REGION: 'setSelectedRegion',
  INIT_AVAILABLE_REGION: 'initAvailableRegion',
  GET_SERVICE_LNB_HIERARCHY_LIST_WITH_SELECTED_REGION: 'getServiceLnbHierarchyListWithSelectedRegion',
  ADD_SERVICE_TO_CALCULATION: 'addServiceToCalculation',
  DELETE_SERVICE_ON_CALCULATION: 'deleteServiceOnCalculation',
  UPDATE_SERVICE_ON_CALCULATION: 'updateServiceOnCalculation',
  SET_SELECTED_REGION_CODE_ON_DETAIL: 'setSelectedRegionCodeOnDetail',
  GET_MAP_PRODUCT_UI_ID_TO_SERVICE: 'getMapProductUiIdToService',
  GET_ADDED_SERVICES_BY_REGION: 'getAddedServicesByRegion',
  GET_AMOUNT_BY_REGION: 'getAmountByRegion',
  SET_SELECTED_MONTH: 'setSelectedMonth',
  RESET_CALCULATION: 'resetCalculation',
  EXPORT_REQUEST: 'exportRequest',
  IS_EMPTY_CALCULATOR: 'isEmptyCalculation',
  GET_SERVICE_DESCRIPTIONS: 'getServiceDescriptions',
  SET_SERVICE_DESCRIPTIONS: 'setServiceDescriptions'
}

const state = {
  isDetailShow: false,
  selectedParentHomepageUiName: 'compute', // @TODO 제거 가능할수도 잇을것 같음. CalculationMain 컴포넌트에서 사용하지 않음.
  selectedHomepageUiName: 'instance',
  selectedCalculationServices: {}, // map, key = productUiId
  regions: [],
  selectedRegion: null,
  addedServices: {
    // serviceId: {}
  },
  addedServiceDetail: {},
  selectedRegionCodeOnDetail: 'KR1',
  selectedMonth: 1,
  serviceDescriptions: {} // Map. key = calculationServiceId
}

const mutations = {
  [types.SET_DETAIL_SHOW](state, isShow) {
    state.isDetailShow = isShow
  },
  [types.SET_SELECTED_PARENT_HOMEPAGE_UI_NAME](state, homepageUiName) {
    state.selectedParentHomepageUiName = homepageUiName
  },
  [types.SET_SELECTED_HOMEPAGE_UI_NAME](state, homepageUiName) {
    state.selectedHomepageUiName = homepageUiName
  },
  [types.SET_SELECTED_CALCULATION_SERVICES](state, calculationServices) {
    state.selectedCalculationServices = calculationServices
  },
  [types.SET_SELECTED_REGION](state, region) {
    state.selectedRegion = region
  },
  [types.INIT_AVAILABLE_REGION](state, regions) {
    state.regions = regions
  },
  [types.ADD_SERVICE_TO_CALCULATION](state, {service, addedServiceData}) {
    // 서비스 템플릿을 그릴 데이터 업데이트
    if (!!state.addedServices[state.selectedRegion.regionCode] === false) {
      Vue.set(state.addedServices, state.selectedRegion.regionCode, {})
    }
    const addedServicesByRegion = state.addedServices[state.selectedRegion.regionCode]
    Vue.set(addedServicesByRegion, service.calculationServiceId, service)

    // 서비스 계산 데이터 업데이트: counterName displayName 등
    if (!!state.addedServiceDetail[state.selectedRegion.regionCode] === false) {
      state.addedServiceDetail[state.selectedRegion.regionCode] = {}
    }
    const addedServiceDetailByRegion = state.addedServiceDetail[state.selectedRegion.regionCode]
    if (!!addedServiceDetailByRegion[service.calculationServiceId] === false) {
      addedServiceDetailByRegion[service.calculationServiceId] = []
    }
    const randomString = window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36)
    const id = `calculator-detail-${service.calculationServiceId}-${randomString}`
    addedServiceDetailByRegion[service.calculationServiceId].push({id, ...addedServiceData})
    // nested 객체 업데이트 감지를 위해서 전체 객체 변경.
    state.addedServiceDetail = Object.assign({}, state.addedServiceDetail)
  },
  [types.SET_SELECTED_REGION_CODE_ON_DETAIL](state, regionCode) {
    state.selectedRegionCodeOnDetail = regionCode
  },
  [types.DELETE_SERVICE_ON_CALCULATION](state, {serviceId, index}) {
    const addedServiceDetailByRegion = state.addedServiceDetail[state.selectedRegionCodeOnDetail]
    addedServiceDetailByRegion[serviceId].splice(index, 1)
    const emptyAddedServiceDetails = addedServiceDetailByRegion[serviceId].length === 0
    if (emptyAddedServiceDetails) {
      // 서비스 템플릿을 그릴 데이터 삭제
      Vue.delete(state.addedServices[state.selectedRegionCodeOnDetail], serviceId)
      if (_isEmpty(state.addedServices[state.selectedRegionCodeOnDetail])) {
        Vue.delete(state.addedServices, state.selectedRegionCodeOnDetail)
      }
      // 서비스 계산 데이터 프로퍼티 삭제
      delete addedServiceDetailByRegion[serviceId]
    }
    // nested 객체 업데이트 감지를 위해서 전체 객체 변경.
    state.addedServiceDetail = Object.assign({}, state.addedServiceDetail)
  },
  [types.UPDATE_SERVICE_ON_CALCULATION](state, {serviceId, index, serviceData}) {
    const addedServiceDetailByRegion = state.addedServiceDetail[state.selectedRegionCodeOnDetail]
    addedServiceDetailByRegion[serviceId][index] = serviceData
    // nested 객체 업데이트 감지를 위해서 전체 객체 변경.
    state.addedServiceDetail = Object.assign({}, state.addedServiceDetail)
  },
  [types.SET_SELECTED_MONTH](state, selectedMonth) {
    state.selectedMonth = selectedMonth
  },
  [types.RESET_CALCULATION](state, payload) {
    Vue.set(state, 'addedServices', {})
    Vue.set(state, 'addedServiceDetail', {})
  },
  [types.SET_SERVICE_DESCRIPTIONS](state, {serviceDescriptions}) {
    state.serviceDescriptions = serviceDescriptions
  }
}

const getters = {
  [types.GET_SERVICE_LNB_HIERARCHY_LIST_WITH_SELECTED_REGION]: (state, getters, rootState) => {
    const serviceLnbHierarchyList = rootState[hierarchyNamespace].calculationLnbHierarchyList
    return _reduce(
      serviceLnbHierarchyList,
      (resultArray, category) => {
        const services = !!state.selectedRegion
          ? _filter(category.services, service =>
            _find(service.regionCodeList, regionCode => regionCode === state.selectedRegion.regionCode || regionCode === 'GLOBAL')
          )
          : category.services
        if (_isEmpty(services) === false) {
          resultArray.push({...category, services})
        }
        return resultArray
      },
      []
    )
  },
  [types.GET_MAP_PRODUCT_UI_ID_TO_SERVICE]: (state, getters, rootState) => {
    const serviceLnbHierarchyList = rootState[hierarchyNamespace].calculationLnbHierarchyList
    let indexAcc = 0
    return _reduce(
      serviceLnbHierarchyList,
      (resultMap, category) => {
        indexAcc++
        resultMap[category.productUiId] = {
          badges: category.badges,
          name: category.name,
          productUiId: category.productUiId,
          displayOrder: indexAcc
        }
        return {
          ...resultMap,
          ..._reduce(
            category.services,
            (servicesOrderMap, service, index) => {
              indexAcc += index
              servicesOrderMap[service.productUiId] = service
              servicesOrderMap[service.productUiId]['displayOrder'] = indexAcc
              return servicesOrderMap
            },
            {}
          )
        }
      },
      {}
    )
  },
  [types.GET_ADDED_SERVICES_BY_REGION]: state => {
    const addedServicesByRegion = state.addedServices[state.selectedRegionCodeOnDetail]
    return _isEmpty(addedServicesByRegion)
      ? []
      : Object.keys(addedServicesByRegion)
        .map(calculationServiceId => state.addedServices[state.selectedRegionCodeOnDetail][calculationServiceId])
        .sort((l, r) => l.displayOrder - r.displayOrder)
  },
  [types.GET_AMOUNT_BY_REGION]: state => {
    return _reduce(
      state.regions,
      (result, region) => {
        const addedServiceDetailByRegion = state.addedServiceDetail[region.regionCode]
        if (!!addedServiceDetailByRegion) {
          result[region.regionCode] = _reduce(
            addedServiceDetailByRegion,
            (amountByService, addedListOnService) => {
              amountByService += sumBy(addedListOnService, 'amount')
              return amountByService
            },
            0
          )
        } else {
          result[region.regionCode] = 0
        }
        return result
      },
      {}
    )
  },
  [types.IS_EMPTY_CALCULATOR]: state => {
    return (
      _isEmpty(state.addedServiceDetail) ||
      _every(state.addedServiceDetail, addedServiceDetailByRegion => _isEmpty(addedServiceDetailByRegion))
    )
  }
}

const actions = {
  [types.GET_CALCULATION_ITEMS_BY_CATEGORY]({state, commit, rootGetters}, {parentHomepageUiName}) {
    const parentProduct = rootGetters[`${hierarchyNamespace}/${hierarchyTypes.GET_SERVICE_LNB_CATEGORY_MAP}`][parentHomepageUiName]
    // 카테고리 내 서비스들에 대한 계산기 데이터 API 호출
    return calculationService
      .getServices$(parentProduct.productUiId, state.selectedRegion.regionCode)
      .pipe(tap(calculationServices => commit(types.SET_SELECTED_CALCULATION_SERVICES, calculationServices)))
      .toPromise()
  },
  [types.GET_SERVICE_DESCRIPTIONS]({state, commit}, {lang}) {
    if (_isEmpty(state.selectedCalculationServices)) return

    const productUiIds = state.selectedCalculationServices.flatMap(service => service.productUiId)
    calculationService.getServiceDescription$(productUiIds, lang, state.selectedRegion.regionCode).subscribe(descriptions => {
      commit(types.SET_SERVICE_DESCRIPTIONS, {serviceDescriptions: descriptions})
    })
  },
  [types.INIT_AVAILABLE_REGION]({state, commit}, payload = {selectedRegionCode: 'KR1'}) {
    return calculationService
      .getRegions$('STABLE')
      .pipe(
        map(regions => {
          const filteredRegions = _filter(regions, region => region.regionCode !== 'GLOBAL' && region.regionCode !== 'UNKNOWN')

          return sortBy(filteredRegions, 'regionPriority')
        }),
        tap(regions => {
          commit(types.INIT_AVAILABLE_REGION, regions)
          const initRegion = _find(regions, region => region.regionCode === payload.selectedRegionCode)
          commit(types.SET_SELECTED_REGION, initRegion || regions[0])
        })
      )
      .toPromise()
  },
  [types.EXPORT_REQUEST](
    {state, rootGetters},
    {type, recipientEmail = null, currencyByCountryPerMonth, currencyByCountry, footerMsg = '', isJp}
  ) {
    let monthlyPrice = 0
    const contents = _reduce(
      state.regions,
      (regionContents, region) => {
        const addedServiceDetailByRegion = state.addedServiceDetail[region.regionCode]
        const addedServicesByRegion = state.addedServices[region.regionCode]
        if (!!addedServicesByRegion === false) return regionContents
        let regionTotalPrice = 0
        const flattenRegionContentItems = _reduce(
          Object.keys(addedServicesByRegion),
          (resultDetails, calculationServiceId) => {
            const service = addedServicesByRegion[calculationServiceId]
            const details = addedServiceDetailByRegion[calculationServiceId]

            const categoryName = service['parentServiceName'] || service['name']
            const concatServiceString = type === 'excel' ? ', ' : '<br>'
            const serviceName = !!service['parentServiceName']
              ? `${service['name']} ${getExtraServiceName(service)}`.trim()
              : _map(
                rootGetters[`${hierarchyNamespace}/${hierarchyTypes.GET_SERVICE_LNB_CATEGORY_MAP}`][parseServiceName(categoryName)]
                  .services,
                'name'
              ).join(concatServiceString)
            const commonServiceInfo = {
              category: categoryName,
              service: serviceName
            }

            const contentItems = _map(details, detail => {
              regionTotalPrice += detail.amount
              const price =
                service.calculationTypeCode !== 'CALCULATION'
                  ? i18n.t(`calculation.calcuation-type.${service.calculationTypeCode.toLowerCase()}`)
                  : `${Vue.options.filters.currency(detail.amount, '', 0)} ${currencyByCountryPerMonth}`
              return {
                ...commonServiceInfo,
                detail: makeAddedServiceDetailToString(service.items, detail.itemsMapData),
                price
              }
            })
            resultDetails = resultDetails.concat(contentItems)
            return resultDetails
          },
          []
        )

        monthlyPrice += regionTotalPrice
        regionContents.push({
          region: i18n.t(`code.regionCode.${region.regionCode}`) + `(${region.regionCode})`,
          items: flattenRegionContentItems,
          regionTotalPrice: `${Vue.options.filters.currency(regionTotalPrice, '', 0)} ${currencyByCountryPerMonth}`
        })
        return regionContents
      },
      []
    )
    const periodText = state.selectedMonth === 12 ? `1${i18n.t('common.year')}` : `${state.selectedMonth}${i18n.t('common.months')}`
    const requestPayload = {
      recipientEmail,
      period: periodText,
      contents,
      monthlyPrice: `${Vue.options.filters.currency(monthlyPrice, '', 0)} ${currencyByCountryPerMonth}`,
      totalPrice: `${Vue.options.filters.currency(monthlyPrice * state.selectedMonth, '', 0)} ${currencyByCountry}`,
      isJp: isJp
    }
    if (type === 'excel') {
      const excelFileName = `${i18n.t('calculation.excel.title')} - ${moment().format('YYYY-MM-DD')}`
      return calculationService.saveExcel(excelFileName, requestPayload)
    } else if (!!recipientEmail && type === 'email') {
      return calculationService.sendEmail$(requestPayload).toPromise()
    }
  }
}

const makeAddedServiceDetailToString = (serviceItems, itemsMapData) =>
  _reduce(
    serviceItems,
    (resultArray, item) => {
      const itemData = itemsMapData[item.itemId]
      if (item.templateTypeCode === 'DROPDOWN_SINGLE_USAGE') {
        const dropdown = `${i18n.t(item.nameMsgId + '.dropdown')}:${i18n.t(itemData.displayName)}`
        const singleUsage =
          `${i18n.t(item.nameMsgId + '.singleUsage')}:` + `${itemData.counterVolume}${i18n.t(item.guideMsgId + '.singleUsage')}`
        resultArray.push(`${dropdown} / ${singleUsage}`)
        return resultArray
      } else if (item.templateTypeCode === 'BLIND_DEFAULT') {
        return resultArray
      }

      let displayItemValue = itemData.displayName
      if (item.templateTypeCode === 'SINGLE_USAGE') {
        displayItemValue = `${itemData.counterVolume}${i18n.t(item.guideMsgId)}`
      } else if (item.templateTypeCode === 'USE_OR_NOT') {
        const useOrNotMsgId = `calculation.common.${itemData.counterVolume === 0 ? 'noUse' : 'use'}`
        displayItemValue = i18n.t(useOrNotMsgId)
      }
      resultArray.push(`${i18n.t(item.nameMsgId)}:${displayItemValue}`)
      return resultArray
    },
    []
  ).join(' / ')

export const calculationStore = {
  state,
  mutations,
  getters,
  actions,
  namespace,
  types
}
